import __RelatedContentInsightsScss from './RelatedContentInsights.scss';
import __RelatedContentInsightsOutlookdesktopScss from './RelatedContentInsights.outlookdesktop.scss';
import { Icon } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { useClientStyles } from 'owa-react-hooks/lib/useClientStyles';
import * as React from 'react';
import {
    relatedContentHeader,
    relatedContentSubHeader,
} from './RelatedContentHeader.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import LightbulbFilamentRegular from 'owa-fluent-icons-svg/lib/icons/LightbulbFilamentRegular';

const styles = {
    base: __RelatedContentInsightsScss,
    desktop: __RelatedContentInsightsOutlookdesktopScss,
};

export interface RelatedContentHeaderProps {
    color: string;
    hideHeader: boolean;
}

const RelatedContentHeader = observer(function RelatedContentHeader(
    props: RelatedContentHeaderProps
) {
    const { getClass } = useClientStyles(styles);
    const showReadingPaneInCards = isFeatureEnabled('mon-cal-showReadingPaneInCards');

    return (
        <>
            {!props.hideHeader && (
                <div className={getClass('headerRow')}>
                    <div className={getClass('insightsIconContainer')}>
                        <Icon
                            iconName={
                                showReadingPaneInCards
                                    ? LightbulbFilamentRegular
                                    : ControlIcons.Insights
                            }
                            className={showReadingPaneInCards ? null : getClass('insightsIcon')}
                            style={{ color: showReadingPaneInCards ? null : props.color }}
                        />
                    </div>
                    <div
                        className={getClass(
                            showReadingPaneInCards
                                ? 'relatedContentCardHeaderText'
                                : 'relatedContentHeaderText'
                        )}
                        style={{ color: showReadingPaneInCards ? null : props.color }}>
                        {loc(relatedContentHeader)}
                    </div>
                </div>
            )}
            <p className={getClass('relatedContentHeaderSubText')}>
                {loc(relatedContentSubHeader)}
            </p>
        </>
    );
});
export default RelatedContentHeader;
